module.exports = __webpack_public_path__ + "img/blog-main-03.2ee82806.jpg";